export default __webpack_public_path__ + "static/media/26.81c75222.png";